import { Component, inject, ViewEncapsulation } from '@angular/core';
import { LoginLayoutComponent as BpLoginLayoutComponent } from '@capturum/login';
import { TranslateService } from '@ngx-translate/core';
import { PublicLocaleService } from '../../../../../public/questionnaire/services/public-locale.service';

/**
 * The base @capturum/login `LoginLayoutComponent` constructor calls
 * `setDefaultLang('nl')` and forces `translateService.use(config.defaultLanguage)`
 * via a tap on its `getConfig()` signal source. That overrides whatever
 * `LgPublicTranslationResolver` and `PublicLocaleService` decided for the
 * login route, and makes the session-expired toast (and the login page
 * itself) render in the wrong language. Re-apply the resolved locale here
 * so our resolution chain wins.
 */
@Component({
  selector: 'app-login',
  templateUrl: 'login-layout.component.html',
  styleUrls: ['./login-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoginLayoutComponent extends BpLoginLayoutComponent {
  readonly #translateService = inject(TranslateService);
  readonly #publicLocaleService = inject(PublicLocaleService);

  constructor() {
    super();

    const target = this.#publicLocaleService.locale;

    if (this.#translateService.currentLang !== target) {
      this.#translateService.use(target);
    }

    if (this.#translateService.defaultLang !== target) {
      this.#translateService.setDefaultLang(target);
    }
  }
}
